import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function SaveCredentials() {
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const saveCredentials = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        if (!session) {
          setStatus("error");
          setMessage("Vous devez être connecté");
          return;
        }

        const { data, error } = await supabase.functions.invoke('save-my-credentials', {
          headers: {
            Authorization: `Bearer ${session.access_token}`
          }
        });

        if (error) throw error;

        setStatus("success");
        setMessage(data.message || "Credentials sauvegardées avec succès!");
        
        // Redirect after 2 seconds
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);

      } catch (error: any) {
        console.error('Error:', error);
        setStatus("error");
        setMessage(error.message || "Erreur lors de la sauvegarde");
      }
    };

    saveCredentials();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-background to-muted">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Sauvegarde des credentials Amazon SP-API</CardTitle>
          <CardDescription>
            Configuration automatique de vos identifiants
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          {status === "loading" && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-primary" />
              <p className="text-center text-muted-foreground">
                Sauvegarde en cours...
              </p>
            </>
          )}
          
          {status === "success" && (
            <>
              <CheckCircle className="h-12 w-12 text-green-500" />
              <p className="text-center font-medium text-green-600">
                {message}
              </p>
              <p className="text-sm text-muted-foreground">
                Redirection vers le dashboard...
              </p>
            </>
          )}
          
          {status === "error" && (
            <>
              <XCircle className="h-12 w-12 text-destructive" />
              <p className="text-center font-medium text-destructive">
                {message}
              </p>
              <Button onClick={() => navigate('/dashboard')}>
                Retour au dashboard
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
